/* eslint-disable max-lines-per-function */
import classNames from "classnames";
import { FC, useEffect } from "react";
import { toastFullDuration } from "../../shipping/hooks/useAppendToast";
import { useBuildOrderErrorEventMessage } from "../hooks/useBuildOrderErrorEventMessage";
import { useDismissToast } from "../hooks/useDismissToast";
import { useShowToastState } from "../hooks/useShowToastState";
import { t } from "../miscellaneous/t";
import { Toast } from "../miscellaneous/toastsAtom";
import { BannerNotification } from "./BannerNotification";

type Props = {
  readonly toast: Toast;
};

const toastDelayRaceDuration = 25;
const toastCssTransitionDuration = 500;

export const ToastBanner: FC<Props> = ({ toast }) => {
  const [showToast, setShowToast] = useShowToastState();

  const orderErrorEventMessage = useBuildOrderErrorEventMessage();
  const errorEventMessage =
    toast.tag === "danger"
      ? t("mk-hc-order-error-form-event", undefined, {
          formTitle: orderErrorEventMessage,
        })
      : "";

  const dismissToast = useDismissToast();
  const handleClose = function () {
    setShowToast(false);
    setTimeout(() => {
      sessionStorage.setItem("collectError", "false");
      dismissToast(toast.joiningKey);
    }, toastCssTransitionDuration);
  };

  useEffect(() => {
    setTimeout(() => {
      setShowToast(true);

      if (toast.tag === "success") {
        setTimeout(() => {
          setShowToast(false);
        }, toastFullDuration - toastDelayRaceDuration - toastCssTransitionDuration);
        return;
      } else {
        return;
      }
    }, toastDelayRaceDuration);
  }, []);

  const animationEnterClass = showToast
    ? "mkhc-toast-visible"
    : "mkhc-toast-invisible";

  return (toast.message ?? "") !==
    "mk-hc-order-error-order-currency-changed" ? (
    <div className={classNames("mkhc-toast", animationEnterClass)}>
      <BannerNotification tag={toast.tag} handleClose={handleClose}>
        <div
          role="status"
          aria-live="assertive"
          className="tw-text-sm tw-font-bold"
        >
          {`${errorEventMessage} ${t(toast.message, undefined, toast.args)}`}
        </div>
      </BannerNotification>
    </div>
  ) : null;
};
